import {getters} from './getters'
import {actions} from './actions'
import {mutations} from './mutations'

// initial state
const state = {
  all_categories: [],
  categories: {},
  error_message: '',
  show_error: false,
  loading: false,
  patientData: {},
  patientDataMap: {},
  parentId: '',
  apiData: 'Waiting',
  index: null,
  indexes: {
    all: [],
    filtered: [],
    errorMessage: null
  },
  viewIndex: {
    _id: null,
    identifier: null,
    name: null,
  },
  viewCategories: {},
  selectedCategoryDefinitions: [],
  filteredCategoryDefinitions: [],
  allCategoryDefinitionsById: {},
  viewAlert: {
    text: '',
    show: false,
    type: 'success',
  },
  nodeMapForUpload: {
    obj: null,
    root_id: null
  },



}

export default {
  state,
  getters,
  actions,
  mutations,
}
